<script>
  import { _ } from "svelte-i18n";
  export let duration;
  let visible = true;
  function remove(){
  visible = false;
  duration = 'removed';
  }
</script>
{#if visible}
<div class="form-subsection">
  <button type="button" on:click={remove} class="form-subsection__button-remove"></button>
  <div class="">
    <div class="">
      <label class="input" for="Varighet (min)">
        <span class="input__label">{$_("sessions.form.mental.content")}</span>
        <input class="input__number  input__number--size-sm" inputmode="numeric" maxlength="15" pattern="[0-9,]*" name="distanse" id="distance-E3F9C79B-433A-4EFD-AF74-5E0AD39A5DCA" autocomplete="off" bind:value={duration}>
      </label>
    </div>
  </div>
</div>
{/if}
